
import {
    WalletModalProvider,
    WalletDisconnectButton,
    WalletMultiButton
} from '@solana/wallet-adapter-react-ui';
import { useWallet } from '@solana/wallet-adapter-react';
import { FaCheckCircle } from "react-icons/fa";
import img from '../../assets/images/1.webp'

import { motion } from 'motion/react';
import { blobAnimation } from '../../animations/animations';
import solLogo from '../../assets/images/solIcon.webp'
import { useSolPrice } from '../../hooks/useSolPrice';
import { Link } from 'react-router-dom';
import { useEffect, useState } from 'react';
import axios from "axios"
import React from 'react';
import { toast } from 'sonner';
import { MdDangerous } from "react-icons/md";
import { useSelector } from 'react-redux';




const WalletButton = WalletMultiButton

export default function WhitelistLayout({ children }) {
    const [loading, setLoading] = useState(false)
    const [user, setUser] = useState(false)

    const { select, publicKey, connected, disconnect, sendTransaction } = useWallet();
    const { solPrice } = useSolPrice()
    const userStoreData = useSelector( state =>state.userSession)

    async function getStats() {
        let endpoint = process.env.REACT_APP_WHITELISTSTATS_ENDPOINT
        const data = await axios.get(endpoint).then((res) => res.data)
    }


    const whitelistEndpoint = process.env.REACT_APP_WHITELIST_ENDPOINT
    const getData = async () => {
        setLoading(true)
        const res = await axios.get(whitelistEndpoint, {
            headers: {
                walletAddress: publicKey.toBase58()
            }
        }).then((res) => res.data)
            setUser(res)
        if (!res.whitelisted) {
            setLoading(false)
            toast.error('You are Not whitelisted Yet')
        }
        setLoading(false)
    }


    useEffect(() => {
        if (user?.whitelisted) {
            toast.success('you are whitelisted')
        }
        connected && getData()
        !connected && setUser(null)
    }, [publicKey, connected,userStoreData])



    return (


        <div className='relative overflow-hidden'>
            <motion.span {...blobAnimation.props} className="bg-blue-500 rounded-full h-[300px] w-[300px] blur-[180px] opacity-50 absolute bottom-[50%] left-0 z-[1]" />
            <motion.span {...blobAnimation.props} className="bg-orange-500 rounded-full h-[300px] w-[300px] blur-[180px] opacity-50 absolute bottom-[50%] right-0 z-[1]" />

            <img src={img} alt="" className="w-full blur-sm absolute top-[2] z-0 opacity-40" />
            <div className="container mx-auto py-5 min-h-[100vh]  h-full relative space-y-10 !z-20">
                <div className="flex justify-between  items-end  shadow-xs p-5 rounded    ">
                    <div className="flex flex-col gap-2 text-neutral-200">
                        <Link to={'/'} className='font-bold text-3xl font-logo tracking-widest text-yellow-500'>Phoenix</Link>
                        {<WalletButton />}
                    </div>



                    <div className=' grid grid-cols-1 gap-2 w-max'>
                                {
                                    user?.whitelisted ? <>

                                        
                                        <p className='text-x flex items-center gap-1 bg-green-500/10 px-4 py-2 rounded-full '> <FaCheckCircle className='text-green-500 text-lg md:text-2xl' />Whitelisted</p></> :
                                        <>
                                           
                                            <p className='text-xs flex items-center gap-1 bg-red-500/10 px-4 py-2 rounded-full'> <MdDangerous className='text-red-500 text-lg md:text-2xl' /> Not Whitelisted</p>
                                        </>
                                }
                            <div className='bg-green-800/20 flex gap-2 px-3 py-2 flex-col rounded-full items-center w-max animate-pulse '>


                                <div className='flex gap-2 items-center'>
                                    <img src={solLogo} alt="" className="h-5" />
                                    {solPrice && <p className='text-green-500 font-bold w-full'>{Number(solPrice).toFixed(2)} $ </p>}
                                </div>
                            </div>
                        </div>

                    {/* <div className="h-max  w-full  flex gap-5 p-5 ">
                        <div className={` border-l-8 rounded-lg border-green-500/20 bg-gradient-to-tl from-yellow-500/10 shadow backdrop-blur-sm to-neutral-500/40 p-2 grow   relative `}>
                            <div className='flex flex-col items-start justify-start gap-2 px-3 py-2'>
                                <p className='text-sm font-bold text-neutral-300'>Total Whitelist Spots</p>
                                <p className='font-bold text-green-600 text-3xl '>15</p>
                            </div>
                        </div>
                        <div className={` border-l-8 rounded-lg border-purple-500/20 bg-gradient-to-tl from-yellow-500/10 shadow backdrop-blur-sm to-neutral-500/40 p-2 grow   relative `}>
                            <div className='flex flex-col items-start justify-start gap-2 px-3 py-2'>
                                <p className='text-sm font-bold text-neutral-300'>Available Whitelist spots</p>
                                <p className='font-bold text-purple-600 text-3xl '>10</p>
                            </div>
                        </div>
                        <div className={` border-l-8 rounded-lg border-yellow-500/20 bg-gradient-to-tl from-yellow-500/10 shadow backdrop-blur-sm to-neutral-500/40 p-2 grow   relative `}>
                            <div className='flex flex-col items-start justify-start gap-2 px-3 py-2'>
                                <p className='text-sm font-bold text-neutral-300'>Total Paid</p>
                                <p className='font-bold text-yellow-600 text-3xl '>18 SOLANA</p>
                            </div>
                        </div>
                    </div> */}

                </div>

                <div className=" ">
                    <div className="flex  gap-2 text-neutral-200 justify-between">
                        <h1 className='heading-large'>Whitelist For Bot and token Launch</h1>
                        
                    </div>
                </div>
                <div className="flex w-full gap-5 z-10">
                    {React.Children.map(children, (child) => {
                        // Check if the child is a valid React element, then clone it with additional props
                        if (React.isValidElement(child)) {
                            return React.cloneElement(child, { solPrice: solPrice, user: user, loading: loading, connected: connected, publicKey: publicKey });
                        }
                        return child; // Return the child if it's not a valid React element (just in case)
                    })}
                </div>

            </div>
        </div>

    )


}